import I18n from 'I18n';
const saveBlobAsFile = (blob, filename) => {
  const a = document.createElement('a');
  a.href = window.URL.createObjectURL(blob);
  a.download = `${filename}-${I18n.moment().format('YYYY-MM-DD')}.csv`;
  a.dispatchEvent(new MouseEvent('click'));
};
export default saveBlobAsFile;